import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

import { computed, ref, watchEffect } from "vue";
import { useToggle } from "../../../composables/useToggle";
import cms from "../../../services/cms/cms";
import SessionSlide from "../../sessions/session-slide.vue";
import CmsChecklist, { AnswerData } from "../cms-checklist.vue";
import VisualPositioningCanvas from "../../sessions/visual-positioning-canvas.vue";
import { CmsSessionSlideWithChecklist } from "../../../services/cms/cms-type-definitions";
import CmsImg from "../cms-img.vue";
import {
  SessionDetails,
  SessionQuestionnaireDetails,
  useSessionQuestionnaire,
} from "../../../composables/useSessionQuestionnaire";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import SlideText from "./slide-text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'checklist-slide',
  props: {
    slice: {},
    index: {},
    sessionDetails: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

const visual = ref<CmsImg | null>(null);
const slide = ref<SessionSlide | null>(null);

const prismicSlice = computed<CmsSessionSlideWithChecklist>(() => {
  return props.slice.prismicSlice as CmsSessionSlideWithChecklist;
});

const sessionQuestionnaireDetails = computed<SessionQuestionnaireDetails>(() => {
  return {
    sliceType: "cms-session-slide-with-checklist",
    ...props.sessionDetails,
  };
});

const { questionnaire, isLoaded } = useSessionQuestionnaire(sessionQuestionnaireDetails.value);

const visualDiv = computed(() => slide?.value?.visualDiv);

const image = computed(() => prismicSlice.value.primary.image);

const checklistId = computed(() => {
  return cms.asText(prismicSlice.value.primary.checklist_id);
});

const checklistAnswers = computed<AnswerData[]>(() => {
  return prismicSlice.value.items.map((e) => {
    return {
      answerLabel: cms.asText(e.checklist_answer_label),
      answerId: cms.asText(e.checklist_answer_id),
    };
  }) as AnswerData[];
});

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

__expose({
  visualDiv,
  visual,
  slide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SessionSlide, {
    ref_key: "slide",
    ref: slide,
    id: 'slide' + props.index,
    "visual-position": "fixed",
    class: _normalizeClass({
      'slide-after-activity': !_unref(isDisplayed),
      'submitted-mapping': _unref(isDisplayed),
    }),
    "data-test": `session-slide-${_ctx.index}`
  }, {
    text: _withCtx(() => [
      _createVNode(SlideText, {
        text: prismicSlice.value.primary.text_body
      }, null, 8, ["text"]),
      (checklistId.value && _unref(isLoaded))
        ? (_openBlock(), _createBlock(CmsChecklist, {
            key: 0,
            "max-choices": prismicSlice.value.primary.max_choices,
            answers: checklistAnswers.value,
            "checklist-id": checklistId.value,
            questionnaire: _unref(questionnaire),
            "is-shuffle": !!prismicSlice.value.primary.checklist_shuffle
          }, null, 8, ["max-choices", "answers", "checklist-id", "questionnaire", "is-shuffle"]))
        : _createCommentVNode("", true)
    ]),
    visual: _withCtx(() => [
      (!!image.value)
        ? (_openBlock(), _createBlock(VisualPositioningCanvas, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(CmsImg, {
                ref_key: "visual",
                ref: visual,
                class: "slide-image",
                src: image.value
              }, null, 8, ["src"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id", "class", "data-test"]))
}
}

})